import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);

import userInfo from './userInfo/';
import common from './common/';
import chat from './chat'

export default new Vuex.Store({
  modules: {
    userInfo,
    common,
    chat
  }
});